export default "__VITE_ASSET__DeI74t$q__"